import React, {Component} from 'react'
import cerrar from '../../img/cerrar.png'

class Pasajeros extends Component{
    constructor(props){
        super(props);
        this.state={

        }
    }

    render(){
        let { closePasa, userViaj } = this.props;
        let valor = userViaj.Pasajeros!==undefined?userViaj.Pasajeros:[];
        return(
            <div className='infinite' style={{width:'100%', height:'100%'}}>
                <div className='cerrarBtn'>
                    <img onClick={closePasa} className='imgC' src={cerrar} alt="menu" />
                </div>
                <hr style={{color:'white', backgroundColor:'white'}}/>
                <p style={{color:'white', fontWeight:'bold', fontFamily:'lato', fontSize:14}}>Pasajeros abordando</p>
                {   
                    valor.map((snap,index) =>{
                    return(
                        <p style={{color:'white', fontWeight:'bold', fontFamily:'lato', fontSize:14, marginTop:5}}>{index+1}. {snap.nombre}</p>
                    )
                })}
            </div>
        )
    }
}
export default Pasajeros;


// WEBPACK FOOTER //
// ./src/Components/perfilEmpleado/pasajeros.js